import React, { useEffect, useState } from "react";
import QuestionCard from "./QuestionCard";
import { Icon } from "@iconify/react";

const UserDashboardFaq = () => {
  const [search, setSearch] = useState("");
  const [userFaq, setUserFaq] = useState([]);

  // load data
  useEffect(() => {
    fetch(`https://servercareseebd.careseebd.com/api/v1/userFaq/getuserFaq`, {
      headers: {
        authorization: `Bearer ${localStorage.getItem("careSeeAccessToken")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.data?.length) {
          setUserFaq(data?.data);
        }
      });
  }, []);

  const filter = userFaq?.filter((faq) =>
    faq?.question?.toLowerCase()?.includes(search?.toLowerCase())
  );

  return (
    <div className="max-w-4xl mx-auto space-y-6 select-none animate-fade-in my-6">
      {/* Header Info Block */}
      <div className="flex items-center gap-3 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm">
        <div className="p-3 bg-indigo-50 text-[#291D89] rounded-xl">
          <Icon icon="solar:question-square-bold" className="w-6 h-6 text-secondary" />
        </div>
        <div>
          <h1 className="text-base font-bold text-slate-800 tracking-tight">Help Center & FAQ</h1>
          <p className="text-xs text-slate-400 font-semibold mt-0.5">Find answers to frequently asked questions about visual exercises</p>
        </div>
      </div>

      {/* Search Input Bar */}
      <div className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
            <Icon icon="solar:magnifer-linear" className="w-4 h-4" />
          </div>
          <input
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-semibold text-slate-800 placeholder-slate-400"
            placeholder="Search questions or topics..."
          />
        </div>
      </div>

      {/* FAQ Cards list */}
      <div className="space-y-4">
        {filter && filter.length > 0 ? (
          filter.map((faq) => (
            <QuestionCard key={faq?._id} faq={faq} />
          ))
        ) : (
          <div className="bg-white p-12 rounded-2xl border border-slate-100 shadow-sm text-center">
            <Icon icon="solar:clipboard-remove-linear" className="w-12 h-12 text-slate-350 mx-auto mb-3" />
            <h3 className="text-sm font-bold text-slate-700">No matching questions found</h3>
            <p className="text-xs text-slate-400 font-semibold mt-1">Try refining your search keyword</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDashboardFaq;
